import { useQuery } from "@tanstack/react-query";

import { getActorsActorIDActorVoices } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTOR_VOICES_QUERY_KEYS } from "./actorVoicesQueryKeys";

export function useActorVoicesQuery(actorID?: string) {
  return useQuery({
    queryKey: ACTOR_VOICES_QUERY_KEYS.list(actorID!),
    queryFn: processResponse(() => getActorsActorIDActorVoices(actorID!)),
    enabled: !!actorID,
  });
}
